import { SheetDescription, SheetTitle } from '@/components/ui/sheet';
import { Counter } from '@/components/ui/counter';
import { Button } from '@/components/ui/button';
import { RefreshIcon } from '@components/icons/RefreshIcon';
import { cn } from '@/lib/utils';
import { useTranslation } from '../../hooks/useTranslation';

interface ActivityCentreHeaderProps {
  count: number;
  onRefresh: () => void;
  isRefreshing: boolean;
}

export function ActivityCentreHeader({
  count,
  onRefresh,
  isRefreshing,
}: ActivityCentreHeaderProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex items-center gap-4">
        <SheetTitle asChild>
          <h2 className="font-inter text-lg font-semibold text-off-black">{t('title')}</h2>
        </SheetTitle>
        <SheetDescription className="sr-only">
          {t('description', 'Background jobs you have queued and their progress.')}
        </SheetDescription>
        <Counter value={count} />
      </div>
      <Button
        variant="tertiary-light"
        onClick={onRefresh}
        disabled={isRefreshing}
        aria-label={t('refresh_aria_label')}
      >
        <RefreshIcon
          className={cn('size-5', isRefreshing && 'motion-safe:animate-spin')}
          aria-hidden="true"
        />
        <span>{t('refresh')}</span>
      </Button>
    </>
  );
}
